import React from "react";
import { Download } from "lucide-react";

const ASSETS = [
  { file: "/brand/tiktok-app-icon-1024.png", name: "أيقونة تطبيق تيك توك", spec: "1024×1024 PNG — حسب متطلبات TikTok for Developers (حتى 5MB)" },
  { file: "/brand/tiktok-app-icon-1024.jpg", name: "أيقونة تيك توك (JPG)", spec: "1024×1024 JPG — بديل أخف" },
  { file: "/brand/logo-1024.png", name: "شعار رواج الذكية", spec: "1024×1024 PNG — الإصدار الذهبي" },
  { file: "/brand/rawaj-mark-source.jpg", name: "العلامة المرجعية", spec: "البرج + رواج الذكية + Rawaj smart" },
  { file: "/brand/rawaj-social-kit.zip", name: "حزمة السوشال", spec: "أغلفة وقصص وهايلايتس" },
];

/** مكتبة رواج: أصول الهوية الجاهزة للتحميل (الأدمن) */
export const BrandAssets = () => (
  <div className="glass rounded-2xl p-6" data-testid="brand-assets">
    <h2 className="text-lg font-bold mb-1">مكتبة رواج — أصول الهوية</h2>
    <p className="text-xs text-muted-foreground mb-4">ملفات جاهزة لمنصات المطوّرين والمتاجر وقنوات التواصل.</p>
    <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
      {ASSETS.map((a) => (
        <a key={a.file} href={a.file} download className="flex items-center gap-3 rounded-xl border border-border bg-background/60 p-3 hover:border-primary/50 transition-colors" data-testid={`brand-asset-${a.file.split("/").pop()}`}>
          {/\.(png|jpg)$/.test(a.file) ? <img src={a.file} alt={a.name} className="w-14 h-14 rounded-lg object-cover border border-border" /> : <div className="w-14 h-14 rounded-lg bg-secondary grid place-items-center text-xs font-bold">ZIP</div>}
          <div className="min-w-0 flex-1">
            <div className="text-sm font-bold truncate">{a.name}</div>
            <div className="text-[11px] text-muted-foreground leading-relaxed">{a.spec}</div>
          </div>
          <Download className="w-4 h-4 text-primary shrink-0" />
        </a>
      ))}
    </div>
  </div>
);
